export class UserDatenRubrikMenge {
    idRubrik: number;
    menge: number;
}
